import { FaCompactDisc, FaPlay } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { CustomButton } from "../ButtonElement";
import { hexToRgba, lightOrDark } from "../HexToRGBA";


export const ContentListContainer = styled.ul`
display: flex;
width: 100%;
max-height: ${props => props.maxHeight && props.maxHeight };
overflow: hidden;
overflow-y: auto;
padding: 2%;
transition: 0.8s all ease;
justify-content: space-evenly;
flex: 1 1 100%;

`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

`


export const TableHeading = styled.th`
  text-align: left;
  border: none;
`

export const TableRow = styled.tr`
text-decoration: none;
flex-direction: column;
width: 100%;
border: none;
align-items: left;
border-radius: 5px;
justify-content: flex-start;
transition: 0.2s all ease;
cursor:pointer;
color: ${props => props.background ? ((lightOrDark(props.theme.mainColor) === "light" && lightOrDark(props.theme.mainBg) === "dark") || ((lightOrDark(props.theme.mainColor) === "dark") && (lightOrDark(props.theme.mainBg) === "light")  )) ? props.theme.mainColor : props.theme.accentColor : props.theme.secondaryBg};
&:hover {
  transition: all 0.2s ease-in-out;
  background-color: ${props => hexToRgba(props.theme.secondaryBg, 0.2)};
  border-radius: 5px;
}
@media screen and (max-width: 480px)
{
  font-size: 1rem;
}

`

export const TableData = styled.td`
border: none;
padding: 1% 1%;

`

export const PlayButton = styled.div`
display: none;
font-size: 0.8rem;
position: absolute;
justify-self: center;
align-self: center;
color: ${props => props.isPlaying ? ((lightOrDark(props.theme.mainColor) === "light" && lightOrDark(props.theme.mainBg) === "dark") || ((lightOrDark(props.theme.mainColor) === "dark") && (lightOrDark(props.theme.mainBg) === "light")  )) ? props.theme.mainColor : props.theme.accentColor :  props.theme.secondaryBg };
background: transparent;
transition: 0.8s all ease;
cursor: pointer;
&:hover {
    color: ${props => props.isPlaying ? props.theme.secondaryBg : props.theme.mainColor };
}

${TableRow}:hover & {
  display: flex;
  z-index: 150;
}

@media screen and (max-width: 960px) {
  font-size: 0.75em;
}

`


export const NumButton = styled.div`
display: flex;
font-size: 0.8rem;
padding: 4% 2%;
color: ${props => props.isPlaying ? ((lightOrDark(props.theme.mainColor) === "light" && lightOrDark(props.theme.mainBg) === "dark") || ((lightOrDark(props.theme.mainColor) === "dark") && (lightOrDark(props.theme.mainBg) === "light")  )) ? props.theme.mainColor : props.theme.accentColor :  props.theme.secondaryBg };
justify-content: space-between;
background: transparent;
transition: 0.8s all ease;
cursor: pointer;
&:hover {
    color: ${(props) => (props.isPlaying ? props.theme?.mainColor ? ((lightOrDark(props.theme?.mainColor) === "light" && lightOrDark(props.theme.mainBg) === "dark") || ((lightOrDark(props.theme?.mainColor) === "dark") && (lightOrDark(props.theme.mainBg) === "light")  )) ? props.theme?.mainColor : props.theme.accentColor : props.theme.secondaryBg : props.theme.secondaryColor )};
}

@media screen and (max-width: 960px) {
  font-size: 0.75em;
}

`


export const ContentListButton = styled(NavLink)`
display: flex;
align-items: center;
background-color: ${props => props.isFocused ? hexToRgba(props.theme.secondaryBg, 0.2) : 'transparent'};
justify-content: flex-start;
align-content: flex-start;
text-decoration: none;
list-style: none;
width: 100%;
padding:  1% 5%;
margin: 0.3% 0%;
transition: 0.2s all ease;
color: ${props => props.background ? ((lightOrDark(props.theme.mainColor) === "light" && lightOrDark(props.theme.mainBg) === "dark") || ((lightOrDark(props.theme.mainColor) === "dark") && (lightOrDark(props.theme.mainBg) === "light")  )) ? props.theme.mainColor : props.theme.accentColor : props.theme.secondaryBg};
cursor:pointer;
border-radius: ${props => props.isFocused ? '5px' : '0px'};
border-bottom: 0.5px solid ${props => hexToRgba(props.theme.secondaryBg,0.1)};
&:hover {
    transition: all 0.2s ease-in-out;
    background-color: ${props => hexToRgba(props.theme.secondaryBg, 0.2)};
    border-radius: 5px;
  }

@media screen and (max-width: 480px)
{
  font-size: 1rem;
}


`
export const DetailsWrapper = styled.div`
display: flex;
align-items: center;
flex: 1 1;
`

export const DetailsContainer = styled.div`
display: flex;
font-size: 0.8rem;
flex-direction: column;
justify-content: flex-start;
z-index: 150;

`
export const DetailsText = styled.text`
  display: flex;
  padding: 0.5% 0%;
  white-space: nowrap;
  overflow: hidden;
  color: ${props => props?.isPlaying ? ((lightOrDark(props.theme.mainColor) === "light" && lightOrDark(props.theme.mainBg) === "dark") || ((lightOrDark(props.theme.mainColor) === "dark") && (lightOrDark(props.theme.mainBg) === "light")  )) ? props.theme.mainColor : props.theme.accentColor : props?.alt ? props.theme.secondaryColor : props?.theme.secondaryBg };
  inline-size: min-content;
  align-items: center;
  text-overflow: ellipsis;
  @media screen and (max-width: 960px) {
    font-size: 0.6rem;
    overflow: hidden;
  }
`

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 3rem;
  height: 3rem;
  align-items: center;
  justify-content: center;

 
  @media screen and (max-width: 960px)
  {
    width: 2.5rem;
    height: 2.5rem;
  }
   
`

export const Img = styled.div`
    display:flex;
    width: 100%;
    height: 100%;
    transition: 1s ease-out;
    border-radius: ${props => props.isCircular ? '50%': '0px'};
    background: ${props => hexToRgba(props.theme.mainBg, 0.9)} url(${props => props.src});
    background-size: cover;
    &:hover {
      transition: all 0.2s ease-in-out;
      opacity: 0.5;
      border-radius: 10px;
  }

  ${TableRow}:hover & {
    transition: all 0.2s ease-in-out;
      opacity: 0.5;
      border-radius: border-radius: ${props => props.isCircular ? '50%': '10px'};;
  }

   

`

export const AdditionalDetailsText = styled.text`
  display: flex;
  font-size: 0.8rem;
  color: ${props => props.background ? ((lightOrDark(props.theme.mainColor) === "light" && lightOrDark(props.theme.mainBg) === "dark") || ((lightOrDark(props.theme.mainColor) === "dark") && (lightOrDark(props.theme.mainBg) === "light")  )) ? props.theme.mainColor : props.theme.accentColor : props.theme.secondaryBg};
  white-space: nowrap;
  padding: 0% 1%;
  justify-content: flex-end;
  flex: 1 1;
  @media screen and (max-width: 960px) {
    font-size: 0.8rem;
  }
`

export const ButtonWrapper = styled.div`
display: flex;
right: 10%;
color: ${(props) => props.background ? props.background : props.theme.accentColor};
margin: 2%;
transition: 0.8s all ease;
justify-content: space-between;
`

export const Button = styled.div`
display: flex;
right: ${props => props.isVisible ? '-150%': '0'};
top: ${props => props.isVisible ? '150%': '0'};
font-size: 1rem;
opacity: 0;
padding: 4% 2%;
margin: 0 1%;
color: ${props => props.active? props.background ? ((lightOrDark(props.theme.mainColor) === "light" && lightOrDark(props.theme.mainBg) === "dark") || ((lightOrDark(props.theme.mainColor) === "dark") && (lightOrDark(props.theme.mainBg) === "light")  )) ? props.theme.mainColor : props.theme.accentColor : props.theme.secondaryBg: props.theme.secondaryBg};
justify-content: center;
background: transparent;
transition: 0.8s all ease;
&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.2);
    border-radius: 10px;
    color: ${(props) => (props.active ? props.background ? ((lightOrDark(props.theme.mainColor) === "light" && lightOrDark(props.theme.mainBg) === "dark") || ((lightOrDark(props.theme.mainColor) === "dark") && (lightOrDark(props.theme.mainBg) === "light")  )) ? props.theme.mainColor : props.theme.accentColor : props.theme.secondaryBg: props.theme.secondaryColor )};
}

${TableRow}:hover & {
  
  z-index: 150;
  opacity: 1;
  right: 10%;
}

@media screen and (max-width: 960px) {
  font-size: 0.75rem;
}

`
export const Button1 = styled.div`
display: flex;
border-radius: 5px;
padding: 2% 5%;
font-size: 0.75rem;
text-align: center;
justify-content: center;
justify-self: center;
z-index: 5;
white-space: nowrap;
border: 1px solid ${props => props.theme.secondaryBg};
color: ${props => props.theme.secondaryBg};
background: ${props =>props.isActive ?   props.theme.mainColor: 'transparent'};
&: hover {
  border: 1px solid ${props => props.theme.mainColor};
  background: ${props => props.isActive ?  'transparent' : props.theme.mainColor};
  color: ${props => props.isActive ? ( lightOrDark(props.theme.mainColor) === 'light' ? 'black' : 'white' ): props.theme.secondaryBg};
}

@media screen and (max-width: 960px) {
  font-size: 0.5rem;
}

`

const Rotate = keyframes`
from {
  transform: rotate(0 deg);
}
to {
  transform rotate(360deg);
}
`

export const PlayingDisc = styled(FaCompactDisc)`
animation: ${Rotate} 4s linear infinite;

`


const slideUp = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

export const WalletWrapper = styled.div`
  min-height: 100vh;
  color: #f1f5f9;
  background-color: ${props => props.theme.mainBg};
  padding: 24px;
  box-sizing: border-box;
  font-family: ui-sans-serif, system-ui, -apple-system, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;

  @media (min-width: 768px) {
    padding: 48px;
  }
`;

export const ToastOverlay = styled.div`
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 384px;
  width: calc(100% - 48px);
  pointer-events: none;
`;

export const ToastCard = styled.div`
  pointer-events: auto;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid ${props => 
    props.type === "success" ? props => props.theme.successColor : 
    props.type === "warning" ? props => props.theme.warningColor : props => props.theme.errorColor
  };
  background-color: rgba(19, 26, 48, 0.95);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  animation: ${slideUp} 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
`;

export const ToastTitle = styled.h5`
  font-weight: 800;
  font-size: 0.75rem;
  margin: 0;
  color: ${props => 
    props.type === "success" ? props => props.theme.successColor : 
    props.type === "warning" ? props => props.theme.warningColor : props => props.theme.errorColor
  };
`;

export const ToastMessage = styled.p`
  font-size: 10px;
  color: #cbd5e1;
  margin-top: 4px;
  margin-bottom: 0;
  line-height: 1.5;
`;

export const LayoutContainer = styled.div`
  max-width: 896px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid ${props => props.theme.secondaryBg};

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const TitleBlock = styled.div``;

export const SectionBadge = styled.span`
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  padding: 4px 12px;
  border-radius: 9999px;
  background-color: rgba(255, 105, 120, 0.1);
  color: ${props => props.theme.mainColor};
  border: 1px solid rgba(255, 105, 120, 0.2);
`;

export const PageTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 900;
  color: ${props => props.theme.secondaryBg};
  margin-top: 12px;
  margin-bottom: 0;
  letter-spacing: -0.025em;
`;

export const PageDescription = styled.p`
  font-size: 0.75rem;
  color: ${props => props.theme.accentColor};
  line-height: 1.625;
  margin-top: 4px;
  margin-bottom: 0;
  max-width: 32rem;
`;

export const BalanceWidget = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 16px;
  background-color: ${props => props.theme.secondaryBg};
  border: 1px solid ${props => props.theme.secondaryBg};
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 768px) {
    width: auto;
  }
`;

export const BalanceDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const BalanceLabel = styled.span`
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
`;

export const BalanceValue = styled.span`
  font-size: 1.25rem;
  font-weight: 900;
  font-family: monospace;
  color: ${props => props.theme.secondaryBg};
`;

export const ResetButton = styled.button`
  padding: 10px 16px;
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: 12px;
  border: 1px solid ${props => props.theme.secondaryColor};
  background-color: ${props => props.theme.secondaryBg};
  color: #cbd5e1;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: auto;

  &:hover {
    background-color: ${props => props.theme.secondaryColor};
    color: ${props => props.theme.secondaryBg};
  }
`;

export const VoucherGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const VoucherCard = styled.div`
  position: relative;
  background-color: ${props => props.theme.mainBg};
  border: 1px solid ${props => props.theme.secondaryBg};
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  @media (min-width: 640px) {
    flex-direction: row;
  }

  &:hover {
    border-color: ${props => props.theme.secondaryColor};
  }

  /* Structural Ticket Cutout Simulation */
  &::before, &::after {
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    background-color: ${props => props.theme.secondaryBg};
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
    z-index: 5;
    display: none;

    @media (min-width: 640px) {
      display: block;
    }
  }

  &::before { left: -12px; }
  &::after { right: -12px; }
`;

export const VoucherMetaGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;

  @media (min-width: 640px) {
    width: auto;
  }
`;

export const CardArtBlock = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 12px;
  background: ${props => props.bgGradient};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.875rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
`;

export const TextDetails = styled.div``;

export const VoucherTitle = styled.h3`
  font-weight: 900;
  font-size: 1rem;
  color: ${props => props.theme.secondaryBg};
  margin: 0;
`;

export const VoucherDescription = styled.p`
  font-size: 0.75rem;
  color: ${props => props.theme.accentColor};
  margin-top: 2px;
  margin-bottom: 0;
`;

export const AllocationLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${props => props.theme.secondaryColor};
  display: block;
  margin-top: 6px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const ClaimActionWrapper = styled.div`
  width: 100%;

  @media (min-width: 640px) {
    width: auto;
  }
`;

export const RedeemButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  
  background-color: ${props => props.isRedeeming ? "rgba(255, 183, 77, 0.1)" : props => props.theme.mainColor};
  color: ${props => props.isRedeeming ? props => props.theme.warningColor : "#080c16"};
  border: ${props => props.isRedeeming ? `1px solid rgba(255, 183, 77, 0.2)` : "none"};
  animation: ${props => props.isRedeeming ? `${pulse} 1.5s infinite ease-in-out` : "none"};

  @media (min-width: 640px) {
    width: auto;
  }

  &:hover {
    filter: ${props => props.isRedeeming ? "none" : "brightness(1.05)"};
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 24px;
  border-radius: 24px;
  gap: 24px;
  animation: ${slideUp} 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
`;

export const EmptyIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #0f172a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.875rem;
`;

export const EmptyTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EmptyTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 900;
  color: ${props => props.theme.secondaryBg};
  margin: 0;
`;

export const EmptyDescription = styled.p`
  font-size: 0.75rem;
  color: ${props => props.theme.accentColor};
  max-width: 24rem;
  line-height: 1.625;
  margin: 0 auto;
`;

export const RedirectButton = styled.button`
  padding: 14px 28px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: none;
  cursor: pointer;
  background-color: ${props => props.theme.mainColor};
  color: #080c16;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.02);
  }

  &:active {
    transform: scale(0.95);
  }
`;
